export const appName = "Evergreen Notes"
export const appURL = "http://localhost:3000"